module.exports = __webpack_public_path__ + "b5a12a12a58e1b0966182c38b56211f6.jpg";